import {
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar'
import { cn } from '@/lib/tailwind.utils'
import { isItemActive } from '@app/utils/isItemActive'
import { ChevronRight } from 'lucide-react'
import { Link, type Location } from 'react-router-dom'
import SidebarItemContent from './SidebarItemContent'
import { MenuItem } from './SidebarMenu'

interface SidebarMenuItemRowProps {
  item: MenuItem
  active: boolean
  hasChildren: boolean
  isSubOpen: boolean
  location: Location
  toggleSubMenu: (key: string) => void
}

const SidebarMenuItemRow = ({
  item,
  active,
  hasChildren,
  isSubOpen,
  location,
  toggleSubMenu,
}: SidebarMenuItemRowProps) => {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={item.label} isActive={active}>
        {item.absolutePath ? (
          <a href={item.path} target="_blank" rel="noreferrer">
            <SidebarItemContent item={item} active={active} />
          </a>
        ) : (
          <Link
            to={item.path}
            onClick={() => {
              if (hasChildren) toggleSubMenu(item.icon)
            }}
          >
            <SidebarItemContent item={item} active={active} />
          </Link>
        )}
      </SidebarMenuButton>

      {hasChildren && (
        <>
          <SidebarMenuAction
            aria-expanded={isSubOpen}
            onClick={(e) => {
              e.stopPropagation()
              toggleSubMenu(item.icon)
            }}
            className="hover:bg-transparent hover:text-inherit"
          >
            <ChevronRight
              className={cn(
                'transition-transform',
                isSubOpen && 'rotate-90',
                active ? 'text-foreground' : 'text-background/80 dark:text-sidebar-accent',
              )}
            />
            <span className="sr-only">Toggle {item.label}</span>
          </SidebarMenuAction>

          {isSubOpen && (
            <SidebarMenuSub className="mt-2">
              {item.children!.map((child) => (
                <SidebarMenuSubItem key={child.path}>
                  <SidebarMenuSubButton
                    asChild
                    isActive={isItemActive(child.path, location.pathname)}
                  >
                    <Link to={child.path}>{child.label}</Link>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              ))}
            </SidebarMenuSub>
          )}
        </>
      )}
    </SidebarMenuItem>
  )
}
export default SidebarMenuItemRow
